import moment from "moment"
import DOMPurify from 'dompurify';
import _ from "lodash";

import Parser from 'html-react-parser';
import { Tooltip } from "primereact/tooltip";
import UserProfile from "../../../common/UserProfile";


const Notification = (props) => {
    const {notification, handleMarkAsRead, routeToReferencePage} = props

    const renderDescription = (notification) => {
        if(!notification.description){
            return ""
        }

        const sanitizedHTML = DOMPurify.sanitize(notification.description)

        return(
            <div>
                {Parser(sanitizedHTML)}
            </div>
        )
    }

    const createdByUserDetails = {
        firstName: notification.createdByUserFirstName,
        lastName: notification.createdByUserLastName,
        profileImg: notification.createdByUserProfileImg
    }

    return (
        <div className="notification-item" key={notification.id} style={{backgroundColor: "#f9f9f9"}}>
            <div className="notification-avatar flex align-self-start ml-1">
                <UserProfile userNameDetails={createdByUserDetails}/>
            </div>
            <div className="notification-details">
                <span className="notification-title">{notification.message}</span>
                <span className="notification-content">{renderDescription(notification)}</span>
                {
                    notification.notificationTypeId === 1 ?
                    <>  
                        <div className="notification-button flex flex-row mt-2">
                            <a onClick={() => routeToReferencePage(`/approvals?approvalInstanceId=${notification.referenceId}`)} style={{fontSize: "12px", cursor: "pointer"}} target="_blank">Go to the Approvals tab</a>
                        </div>
                    </> : null
                }
                <div className="notification-timestamp">
                    <span>{moment(notification.createdAt).format('dddd h:mmA').toLowerCase()}</span>
                    <span>{moment(notification.createdAt).format('MMM D, YYYY')}</span>
                </div>
            </div>
            <>
                <div className={`custom-tooltip-${notification.notificationId}`} style={{ width: "5%", height: "100%", cursor: 'pointer', alignSelf: "flex-start"}} onClick={() => handleMarkAsRead("notificationId", notification.notificationId)}>
                    <span className="notification-dot"></span>
                </div>
                <Tooltip target={`.custom-tooltip-${notification.notificationId}`} style={{alignSelf: "flex-start"}} position="top" autoHide>
                    <p className="m-0 p-0" style={{fontSize: "12px"}}>Mark As Read</p>
                </Tooltip>
            </>
        </div>
    )
}

export default Notification;
